<template>
  <div class="counter">
    <img
      :src="carrotImgUrl"
      alt=""
      aria-hidden="true"
      width="628"
      height="782"
      loading="lazy"
      class="counter__img"
    />
    <div class="counter__value">{{ props.score }}</div>
  </div>
</template>

<script setup lang="ts">
import carrotImgUrl from '@/assets/images/carrot.webp?url'

const props = defineProps({
  score: {
    type: Number,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
.counter {
  position: absolute;
  top: 0;
  right: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 17rem;
  height: 5.6rem;
  padding: 1rem 4rem 1rem 8rem;
  border: 0.1rem $c-rabbit solid;
  border-radius: 3rem;
  scale: 0.6;
  translate: 50% 0;
  transform-origin: 50% 50%;

  @include mq($from: m) {
    right: 0;
    scale: 1;
    translate: 0 0;
  }
}

.counter__img {
  position: absolute;
  top: 50%;
  left: 0;
  width: 11.5rem;
  height: 11.5rem;
  translate: -10px -55%;
  rotate: -22deg;
}

.counter__value {
  color: $c-rabbit;
  font-family: $ff-alt;
  font-size: 3rem;
  font-weight: 900;
  line-height: 2;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  font-variant-numeric: tabular-nums;
}
</style>
